// const { areaSet, areaMap } = require('./area.js');
// (店舗詳細ページの) .detalList__item の要素を取得
const shopAreaElement = document.querySelector('.detalList__item');
if (!shopAreaElement) {
    return;
}
// data-shop-area 属性の値を取得
const shopArea = shopAreaElement.getAttribute('data-shop-area');
// (店舗詳細ページの) .area__item のリストを取得
const areaItems = document.querySelectorAll('.pageShoplistdetal .area__item');

// areaItems の各アイテムのテキストと shopArea を比較
areaItems.forEach(item => {
    if (item.textContent.trim() === shopArea) {
        // 一致する場合、active クラスを追加
        item.classList.add('active');
        const areaLabel = document.querySelector('.pageShoplistdetal .areaLabel');
        let areaLabelImg = areaLabel.querySelector('img')
        areaLabelImg.src = item.dataset.titleSrc;
        areaLabelImg.alt = item.dataset.area + 'エリア';

    }
});
